<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-logo">
        <span class="logo-text">TechStudio</span>
      </div>
      <p class="copyright">
        &copy; {{ new Date().getFullYear() }} TechStudio. All rights reserved. <br/>
        专注数字体验，用代码创造价值。
      </p>
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">滇ICP备2024039279号-3</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: var(--surface-color);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 60px 20px;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.logo-text {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-primary);
  opacity: 0.8;
}

.copyright {
  margin-top: 20px;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.8;
}

.icp-info {
  margin-top: 12px;
  font-size: 14px;
  
  a {
    color: var(--text-secondary);
    transition: color var(--transition-speed) ease;
    
    &:hover {
      color: var(--primary-color);
    }
  }
}
</style>
